import { useMutation, useQueryClient } from '@tanstack/react-query'
import { redirectToLogout } from '@/shared/api'

// Выход через единый SSO (00-architecture § 3): чистим локальный кэш (в нём личные
// данные ушедшей сессии) и уходим на id.stit.tech/auth/logout — он гасит
// hub-сессию, ставит tombstone и чистит cookie. Своей ручки logout у продукта нет.
export function useLogout() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => {},
    onSettled: () => {
      qc.clear()
      redirectToLogout()
    },
  })
}
